// extracted by mini-css-extract-plugin
module.exports = {"frame":"image-frame_frame__ln_zI","image":"image-frame_image__Rr0Ze","secondary":"image-frame_secondary__vMzRu"};